import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Menu } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { WorkforceReadinessMobileNav } from '@/features/workforce-readiness/components/WorkforceReadinessMobileNav';
import { WorkforceReadinessNav } from '@/features/workforce-readiness/components/WorkforceReadinessNav';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/workforce-readiness')({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/workforce-readiness' ||
      location.pathname === '/workforce-readiness/'
    ) {
      // TanStack Router expects redirect to be thrown as control flow
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/workforce-readiness/training-register', replace: true });
    }

    return {
      getTitle: () => i18n.t('routeTitles.workforceReadiness'),
    };
  },
  component: WorkforceReadinessLayout,
});

function WorkforceReadinessLayout() {
  const { t } = useTranslation('common');
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="flex min-h-[calc(100vh-4rem)]">
      <WorkforceReadinessNav />

      <WorkforceReadinessMobileNav open={mobileNavOpen} onOpenChange={setMobileNavOpen} />

      <div className="flex-1 overflow-auto">
        <div className="sticky top-0 z-10 flex items-center border-b bg-background px-4 py-2 md:hidden">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => {
              setMobileNavOpen(true);
            }}
            aria-label={t('workforceReadiness.nav.ariaOpenNavigation')}
            className="h-11 w-11"
          >
            <Menu className="h-5 w-5" />
          </Button>
          <span className="ml-2 text-sm font-medium text-muted-foreground">{t('workforceReadiness.nav.title')}</span>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
